<!-- 由 suu 创建于 2021-12-27 星期一 -->
<template>
  <div class="die-selection-rule">
    <!-- 浮窗按钮 -->
    <div class="ds-fbtn ds-fbtn-rule user-btn" @click="handelToRank">
      营养师排行榜
    </div>
    <!-- 内容 -->
    <img
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/syr-exp-bg?v=2"
      alt=""
    />
    <!-- 定位锚点 -->
    <div class="dsr-ref" id="refEle"></div>
    <!-- 底部按钮 -->
    <div class="f-btn-end" v-if="[-1, -2].includes(voteNum)">
      {{ voteNum == -1 ? '活动已结束' : '活动未开始' }}
    </div>
    <div class="ds-footer" v-else>
      <div class="f-btn user-btn" @click="handelShare">邀请好友帮忙</div>
      <div class="f-btn f-btn-2 user-btn" @click="bindClock">我要打call</div>
    </div>
    <!-- 小程序分享引导 -->
    <van-overlay :show="showShare" @click="showShare = false">
      <div class="share-image-content">
        <img
          class="ds-share-img"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-share-guide?time=1224"
          alt=""
        />
      </div>
    </van-overlay>
    <!-- 海报 -->
    <SelPoster
      v-if="showPoster"
      :invitedCode="invitedCode"
      @close="showPoster = false"
      @over=""
    ></SelPoster>
  </div>
</template>

<script>
import SelPoster from './ponents/sel-poster'

export default {
  name: 'die-selection-rule',

  components: { SelPoster },

  props: {},

  data() {
    return {
      showPoster: false, // 海报
      isAPP: false, // 是否在app
      isAppLogin: null, // app是否登录
      isMini: false,
      showShare: false,
      invitedCode: '',
      voteNum: 0
    }
  },

  computed: {},

  watch: {},

  created() {
    if (this.$http._isApp()) {
      this.isAPP = true
      this.getVote() // 未登录也有游客token 可调接口
      // 获取token后 调用接口更新数据
      this.$betterwe.isLogin(() => {
        this.getStr()
      })
    } else {
      wx.miniProgram.getEnv((res) => {
        this.isMini = res.miniprogram
        // 回调放在里面
        this.getStr()
        this.getVote()
      })
    }
  },

  mounted() {
    this.$nextTick(() => {
      // this.$toast(document.documentElement.clientHeight * 1 + 1 < 680)
      if (this.$route.query.showRef) {
        document.querySelector('#refEle').scrollIntoView(true)
      }
    })
  },

  destroyed() {},

  methods: {
    // 跳转排行榜
    handelToRank() {
      if (this.isApp && this.isAppLogin !== 1) {
        let obj = {
          path: '/loginPhone'
        }
        this.$betterwe.onAppPageRoute(obj)
        return false
      }
      this.$router.replace('/die-selection')
    },
    /**
     * 获取投票数
     */
    getVote() {
      this.$http.getApp('member/AppVote/getVote', {}).then((res) => {
        if (res.data.code == 200) {
          this.voteNum = res.data.data
        } else if (res.data.code == 4001) {
          this.voteNum = -2
        }
      })
    },
    /**
     * 埋点
     */
    addLog(from) {
      this.$http
        .getApp('member/StorageLogin/spotLog', { from, type: 3 })
        .then((res) => {})
    },
    //去小程序去打call
    bindClock() {
      this.addLog('明星减脂营-营养师评选获取额外票数')
      if (this.isAPP) {
        let obj = {
          path: '/ugcPublish', //跳转页面路径
          //跳转所需参数
          params: [
            { key: 'activityType', value: 1 },
            { key: 'tabIndex', value: 1 }
          ]
        }
        if (this.isAppLogin !== 1) {
          obj = {
            path: '/loginPhone'
          }
        }
        this.$betterwe.onAppPageRoute(JSON.stringify(obj))
      } else if (this.isMini) {
        if (this.isMini) {
          let topic = {
            id: 16
          }
          wx.miniProgram.navigateTo({
            url:
              '/pages/publish/publish?publishType=1&topic=' +
              JSON.stringify(topic)
          })
        }
      }
    },
    /**
     * 获取转介串
     */
    getStr() {
      // 先判断app  满足 return
      if (this.isAPP) {
        this.$http
          .getApp('member/AppVote/getRandStr', {
            channel_id: 1,
            type: 1
          })
          .then((res) => {
            this.invitedCode = res.data.data
          })
      } else if (this.isMini) {
        // 判断 小程序
        this.$http
          .getApp('member/AppVote/getRandStr', {
            channel_id: 1,
            type: 2
          })
          .then((res) => {
            this.invitedCode = res.data.data
            // 小程序分享配置
            let params = {
              title: '为喜爱的营养师打call，领取100元优惠礼包！',
              imageUrl:
                'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/syr-share'
            }
            this.setWxShare(params)
          })
      }
    },
    //设置微信分享或者转发
    setWxShare({ title, imageUrl }) {
      const link = location.origin + location.pathname
      const miniObj = {
        title,
        imageUrl,
        path:
          '/pages/webview/webview?url=' +
          encodeURIComponent(link) +
          `&invitedCode=${this.invitedCode}`
      }
      wx.miniProgram.postMessage({
        data: miniObj
      })
    },
    /**
     * 分享配置 小程序  APP
     */
    handelShare() {
      this.addLog('明星减脂营-营养师评选邀请好友')
      if (this.isAPP) {
        if (this.isAppLogin !== 1) {
          let obj = {
            path: '/loginPhone'
          }
          this.$betterwe.onAppPageRoute(JSON.stringify(obj))
          return
        }
        // app分享配置
        this.showPoster = true
      } else {
        this.showShare = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.die-selection-rule {
  width: 100vw;
  position: relative;
  padding-bottom: 52px;
  background: #feeaef;
  .ps_pic {
    width: 60vw;
  }
  .test {
    font-size: 10px;
  }
  .ds-fbtn {
    width: 28px;
    height: 88px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 0;
    top: 66px;
    background: #ee484b;
    color: #fff;
    font-size: 12px;
    box-sizing: border-box;
    padding: 0 8px;
    line-height: 13px;
    font-weight: 450;
  }
  .dsr-ref {
    width: 100%;
    box-sizing: border-box;
    height: 10px;
    position: absolute;
    z-index: 5;
    // background: yellowgreen;
    top: 2500px;
  }
  img {
    width: 100%;
    box-sizing: border-box;
  }
  .ds-footer {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    font-size: 18px;
    font-family: eryazhenyuanjian;
    color: #ffffff;
    .f-btn {
      width: 50%;
      height: 52px;
      box-sizing: border-box;
      background: #9c79cf;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
    }
    .f-btn-2 {
      background: linear-gradient(207deg, #f28a6c 0%, #ed629b 100%);
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  .f-btn-end {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 52px;
    box-sizing: border-box;
    background: #999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .share-image-content {
    display: flex;
    justify-content: flex-end;
    .ds-share-img {
      width: 65%;
    }
  }
}
</style>
